<template>
  <SfTabs :open-tab="1" class="shop-products">
    <SfTab v-if="changeProduct == false" title="Продукты магазина">
      <div class="message" style="display: flex; align-items: center;">
        <form action="">
          <label>
            <span class="sf-button" href="#">
              Импортировать
            </span>
            <input @change="handleImport" style="display: none;" type="file" name="file" />
          </label> 
        </form>
        <SfButton @click="productData = productDataEmpty; changeProduct = true" style="margin-left: 15px;">Добавить продукт</SfButton>
        <SfButton @click="selectProducts = !selectProducts; checkedProducts = []" style="margin-left: 15px;">Отметить</SfButton>
        <SfButton v-if="selectProducts" @click="deleteCheckedProducts" style="margin-left: 15px;" class="color-danger">Удалить</SfButton>
      </div>
      <div class="search" style="display: flex;">
        <SfInput
          label="Поиск"
          type="search"
          v-model="filtersValues.search"
          style="flex: 1;"
        />
        <SfButton @click="searchProducts" >Поиск</SfButton>
      </div>
      <SfLoader :class="{ loading }" :loading="loading">
        <div class="products" v-if="!loading && products.length > 0">
          <transition-group
            appear
            name="products__slide"
            tag="div"
            class="products__grid"
          >
            <template v-for="(product, i) in products">
                <SfProductCard
                  :key="product.slug"
                  :title="product.name"
                  :style="{ '--index': i }"
                  :image="getImage(product.image)"
                  :regular-price="productPrice(product)"
                  :link="{ name: 'product', params: { slug: product.slug } }"
                  class="products__product-card"
                >
                  <template #price>
                    <div v-if="selectProducts" class="product__select-wrapper" @click="checkProduct(product.id)" :class="{ active: checkedProduct(product.id) }">
                      <SfIcon v-if="checkedProduct(product.id)" icon="check" size="xl4" />
                    </div>
                    <div class="sf-price sf-product-card__price">
                      <span class="sf-price__regular">{{ productPrice(product) }}</span>
                    </div>  
                    <div class="sf-price sf-product-card__price" style="display: flex; justify-content: space-between; align-items: center;">
                      <span>{{ product.category.name }}</span>
                      <span>Просмотры: {{ product.view || 0 }}</span>
                    </div>
                    <div class="sf-price sf-product-card__price" style="display: flex; justify-content: space-between; align-items: center;">
                      <a href="#" @click="productData = {...product, is_on_main: product.is_on_main == true }; changeProduct = true;">Изменить</a>
                      <a href="#" @click="(e) => deleteProduct(e, product.id)" style="color: red;">Удалить</a>
                    </div>
                  </template>
                </SfProductCard>
            </template>
          </transition-group>
          <SfPagination
            v-if="!loading"
            data-cy="category-pagination"
            class="products__pagination"
            v-show="pagination.totalPages > 1"
            :current="pagination.currentPage"
            :total="pagination.totalPages"
            :visible="5"
          >
            <template #number="{ page }">
              <a @click="setCurrentPage(page)" :class="{ active: pagination.currentPage === page }" class="sf-link sf-pagination__item" style="outline: none; cursor: pointer;"> {{ page }} </a>
            </template>
            <template #prev="{ isDisabled }">
              <button class="special-button" @click="() => setCurrentPage(pagination.currentPage - 1)" :disabled="isDisabled ? true : false">пред.</button>
            </template>
            <template #next="{ isDisabled }">
              <button class="special-button" @click="() => setCurrentPage(pagination.currentPage + 1)" :disabled="isDisabled ? true : false">след.</button>
            </template>
          </SfPagination>
        </div>
        <div style="display: flex; min-height: 50vh; justify-content: center; width: 100%; align-items: center;" v-else-if="products.length == 0" class="product-not-found">
          
          <span class="navbar__label">Товаров не найдено...</span> 
        </div>
      </SfLoader>
    </SfTab>
    <SfTab v-else :title="productData.id ? 'Изменить продукт' : 'Добавить продукт'">
      <p class="message" style="display: flex; align-items: center;">
        <SfButton @click="changeProduct = false">Назад</SfButton>
      </p>
      <form class="form" @submit="updateInfo">
        <SfInput
          v-model="productData.name"
          name="name"
          label="Название"
          required
          class="form__element"
        />
        <SfInput
          v-model="productData.price"
          name="price"
          label="Цена"
          type="number"
          class="form__element"
        />
        <SfInput
          v-model="productData.weight"
          name="weight"
          label="Вес"
          type="number"
          step=".01"
          class="form__element"
        />
        <SfInput
          v-model="productData.specification_carat"
          name="specification_carat"
          label="Карат"
          type="number"
          step=".01"
          class="form__element"
        />
        <SfTextarea
          style="width: 100%"
          v-model="productData.description"
          name="description"
          label="Описание"
          class="form__element"
        />
        <SfSelect label="Категория" valid name="category_id" v-model="productData.category_id" placeholder="Выберите из вариантов...">
          <SfSelectOption
            v-for="category in categories"
            :key="category.id"
            :value="String(category.id)"
          >
            {{ category.name }}
          </SfSelectOption>
        </SfSelect>
        <SfSelect label="Метал" valid name="specification_metal" v-model="productData.specification_metal" placeholder="Выберите из вариантов...">
          <SfSelectOption
            v-for="(title, value) in specifications.metal"
            :key="value"
            :value="value"
          >
            {{ title }}
          </SfSelectOption>
        </SfSelect>
        <multiselect placeholder="Доп. категории" style="width: 100%; max-width: 100%;" :multiple="true" :close-on-select="false" track-by="id" label="name" v-model="productData.categories" :options="categories">
        </multiselect>
        <SfSelect label="Вставка" valid name="specification_insert" v-model="productData.specification_insert" placeholder="Выберите из вариантов...">
          <SfSelectOption
            v-for="(title, value) in specifications.insert"
            :key="value"
            :value="value"
          >
            {{ title }}
          </SfSelectOption>
        </SfSelect>
        <SfSelect label="Вставка 2" valid name="specification_insert2" v-model="productData.specification_insert2" placeholder="Выберите из вариантов...">
          <SfSelectOption
            v-for="(title, value) in specifications.insert"
            :key="value"
            :value="value"
          >
            {{ title }}
          </SfSelectOption>
        </SfSelect>
        <SfSelect label="Вставка 3" valid name="specification_insert3" v-model="productData.specification_insert3" placeholder="Выберите из вариантов...">
          <SfSelectOption
            v-for="(title, value) in specifications.insert"
            :key="value"
            :value="value"
          >
            {{ title }}
          </SfSelectOption>
        </SfSelect>
        <SfSelect label="Проба" valid name="specification_probe" v-model="productData.specification_probe" placeholder="Выберите из вариантов...">
          <SfSelectOption
            v-for="(title, value) in specifications.probe"
            :key="value"
            :value="value"
          >
            {{ title }}
          </SfSelectOption>
        </SfSelect>
        <SfSelect label="Для кого" valid name="specification_for-who" v-model="productData['specification_for-who']" placeholder="Выберите из вариантов...">
          <SfSelectOption
            v-for="(title, value) in specifications.forWho"
            :key="value"
            :value="value"
          >
            {{ title }}
          </SfSelectOption>
        </SfSelect>
        <SfSelect label="Размер" valid name="specification_size" v-model="productData.specification_size" placeholder="Выберите из вариантов...">
          <SfSelectOption
            v-for="(title, value) in specifications.size"
            :key="value"
            :value="value"
          >
            {{ title }}
          </SfSelectOption>
        </SfSelect>
        <div style="display: flex; justify-content: space-between; align-items: center; align-items: flex-start;">
          <img style="width: 10%;" v-if="productData.image" :src="getImage(productData.image)" alt="">  
          <SfInput
            type="file"
            name="image"
            label="Изображение"
            :required="productData.image ? false : true"
            class="form__element"
            style="flex: 1; margin-left: 15px;"
          />
        </div>

        <div style="display: flex; justify-content: space-between; align-items: center; align-items: flex-start; width: 100%;">
          <SfInput
            type="file"
            name="images"
            label="Изображения"
            class="form__element"
            style="flex: 1;"
            multiple
          />
        </div>
        <div style="width: 100%; margin-bottom: 30px;">
          <SfCheckbox
            v-model="productData.is_on_main"
            name="is_on_main"
            label="На главной"
            :value="1"
          />  
        </div>
        
        <SfButton class="form__button classic-button"
          >Сохранить
        </SfButton>
      </form>
      <p class="notice">
        Используя наш сайт вы соглашаетесь с нашей
        <router-link :to="{ name: 'page', params: { slug: 'privacy' } }">
          политикой конфиденциальности и обработки данных.
        </router-link>
      </p>
    </SfTab>
  </SfTabs>
</template>
<script>
import { SfTabs, SfPagination, SfLoader, SfProductCard, SfButton, SfInput, SfTextarea, SfCheckbox, SfSelect, SfIcon } from "@storefront-ui/vue";
import apiRequest from '../../shared/apiRequest'
import Multiselect from 'vue-multiselect'

export default {
  name: "PersonalDetails",
  components: {
    SfTabs,
    SfPagination,
    SfLoader,
    SfProductCard,
    SfSelect,
    SfButton,
    SfInput, SfTextarea, SfCheckbox,
    SfIcon,
    Multiselect
  },
  props: {
    account: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      changeProduct: false,
      selectProducts: false,
      loading: true,
      pagination: {
        totalItems: 10,
        totalPages: 3,
        currentPage: 1,
      },
      categories: [],
      products: [],
      productDataEmpty: {
        name: "",
        category_id: 1,
        specification_metal: null,
        specification_insert: null,
        specification_insert2: null,
        specification_insert3: null,
        specification_carat: null,
        specification_probe: null,
        "specification_for-who": null,
        price: null,
        size: null,
        weight: null,
        is_on_main: 0,
        description: '',
      },
      productData: {
        name: "",
        category_id: 1,
        specification_metal: null,
        specification_insert: null,
        specification_insert2: null,
        specification_insert3: null,
        specification_carat: null,
        specification_probe: null,
        "specification_for-who": null,
        price: null,
        size: null,
        weight: null,
        is_on_main: 0,
        description: '',
        categories: []
      },
      filtersValues: {
        search: ''
      },
      specifications: {
        metal: {
          "gold": "Золото",
          "white_gold": "Белое золото",
          "yellow_gold": "Желтое золото",
          "red_gold": "Красное золото",
          "combined_gold": "Комбинированное золото",
          "white_platinum": "Белая платина"
        },
        insert: {
          "empty": "Без камня",
          "agate": "Агат",
          "amethyst": "Аметист",
          "beryl": "Берилл",
          "turquoise": "Бирюза",
          "turquoise_them.": "Бирюза им.",
          "diamond": "Бриллиант",
          "refined_diamond": "Бриллиант облагороженный",
          "simplified_cut_diamond": "Бриллиант упрощенной огранки",
          "rhinestone": "Горный хрусталь",
          "garnet": "Гранат",
          "pearl": "Жемчуг",
          "pearl_cult.": "Жемчуг культ.",
          "emerald": "Изумруд",
          "synthetic_emerald": "Изумруд синтетический",
          "iolite": "Иолит",
          "quartz": "Кварц",
          "ceramics": "Керамика",
          "coral": "Коралл",
          "corundum": "Корунд",
          "synthetic_corundum": "Корунд синтетический",
          "larimar": "Ларимар",
          "leucosapphire": "Лейкосапфир",
          "mystic_quartz": "Мистик-кварц",
          "moissanite_synthetic": "Муассанит синтетический",
          "onyx": "Оникс",
          "synthetic_opal": "Опал синтетический",
          "nacre": "Перламутр",
          "rauchtopaz": "Раухтопаз",
          "rhodolite": "Родолит",
          "ruby": "Рубин",
          "ruby glass": "Рубин стекло",
          "synthetic_ruby": "Рубин синтетический",
          "with_stone": "С камнем",
          "sapphire": "Сапфир",
          "diffusion_sapphire": "Сапфир диффузионный",
          "sapphire_synthetic": "Сапфир синтетический",
          "sapphire_colored": "Сапфир цветной",
          "synthetic_insert": "Синтетическая вставка",
          "synthetic_stone": "Синтетический камень",
          "topaz": "Топаз",
          "topaz_london": "Топаз лондон",
          "tourmaline": "Турмалин",
          "cubic_zirconia": "Фианит",
          "chalcedony": "Халцедон",
          "chrysolite": "Хризолит",
          "chrysoprase": "Хризопраз",
          "zircon": "Циркон",
          "citrine": "Цитрин",
          "enamel": "Эмаль",
          "amber": "Янтарь",
          "natural_freshwater_pearls": "Натуральный пресноводный жемчуг"
        },
        insertColor: {
          "empty": "Без вставки",
          "white": "Белый",
          "blue": "Блю",
          "cornflower": "Васильковый",
          "blue_2": "Голубой",
          "smoky": "Дымчатый",
          "yellow": "Желтый",
          "green": "Зеленый",
          "cognac": "Коньячный",
          "brown": "Коричневый",
          "red": "Красный",
          "mystic": "Мистик",
          "orange": "Оранжевый",
          "pink": "Розовый",
          "blue2": "Синий",
          "purple": "Фиолетовый",
          "color": "Цветной",
          "black": "Черный",
          "champagne": "Шампань"
        },
        stoneCut: {
          "empty": "Без огранки",
          "baguette": "Багет",
          "bead": "Бусина",
          "vintage": "Винтаж",
          "faceted": "Граненый",
          "pear": "Груша",
          "emerald": "Изумрудная",
          "square": "Квадрат",
          "round": "Круглая",
          "cushion": "Кушон",
          "marquis": "Маркиз",
          "oval": "Овал",
          "princess": "Принцесса",
          "rectangular": "Прямоугольная",
          "the_rose": "Роза",
          "heart": "Сердце",
          "fantasy": "Фантазийная"
        },
        probe: {
          "375": "375",
          "500": "500",
          "583": "583",
          "585": "585",
          "750": "750",
          "925": "925",
          "950": "950"
        },
        forWho: {
          "womans": "Женщины",
          "mans": "Мужчины",
          "unisex": "Унисекс",
          "youngs": "Подростковый",
          "kids": "Дети"
        },
        style: {
          "vanguard": "Авангард",
          "fishnet": "Ажурные",
          "diamond edge": "Алмазная грань",
          "antique": "Антикварные",
          "butterfly": "Бабочка",
          "bow": "Бантик",
          "infinity": "Бесконечность",
          "wedding": "Венчальное",
          "vintage": "Винтажные",
          "oriental": "Восточные",
          "nut": "Гайка",
          "geometry": "Геометрия",
          "engraving": "Гравировка",
          "double": "Двойные",
          "designer": "Дизайнерские",
          "for_lovers": "Для влюбленных",
          "track": "Дорожка",
          "inflated": "Дутые",
          "animals": "Животные",
          "snake": "Змея",
          "square": "Квадрат",
          "classic": "Классические",
          "classic engagement": "Классические обручальные",
          "crown": "Корона",
          "pigtail": "Косичка",
          "spinning": "Крутящееся",
          "wing": "Крыло",
          "sheet": "Лист",
          "love": "Любовь",
          "raspberry": "Малина",
          "marquise": "Маркиза",
          "massive": "Массивные",
          "soft": "Мягкий",
          "on_foot": "На ногу",
          "typesetting": "Наборное",
          "inscription": "Надпись",
          "fancy": "Необычные",
          "original": "Оригинальные",
          "ring": "Перстень",
          "flat": "Плоское",
          "round": "По кругу",
          "everyday": "Повседневные",
          "engagement": "Помолвочное",
          "the kiss": "Поцелуйчик",
          "princess": "Принцесса",
          "simple": "Простое",
          "heel": "Пяточка",
          "strap": "Ремешок",
          "the_rose": "Роза",
          "rhombus": "Ромб",
          "placer": "Россыпь",
          "wedding2": "Свадебные",
          "traffic lights": "Светофор",
          "heart": "Сердце",
          "vintage2": "Старинные",
          "dancing stone": "Танцующий камень",
          "thick": "Толстые",
          "thin": "Тонкие",
          "trinity": "Тринити",
          "triple": "Тройное",
          "phalanx": "Фаланга",
          "flowers": "Цветы",
          "turban": "Чалма",
          "turtle": "Черепаха",
          "washer": "Шайба",
          "ball": "Шар",
          "balloons": "Шарики",
          "wide": "Широкие",
          "exclusive": "Эксклюзивные",
          "elite": "Элитные"
        },
        type: {
          "like-new": "Как новое",
          "new": "Новое"
        },
        size: {
          "15": "15",
          "16": "16",
          "17": "17",
          "18": "18",
          "19": "19",
          "20": "20",
          "21": "21",
          "22": "22",
          "23": "23",
          "24": "24",
          "13.5": "13.5",
          "14.5": "14.5",
          "15.5": "15.5",
          "16.5": "16.5",
          "17.5": "17.5",
          "18.5": "18.5",
          "19.5": "19.5",
          "20.5": "20.5",
          "21.5": "21.5",
          "22.5": "22.5"
        },
      },

      checkedProducts: []
    };
  },
  watch: {
    account: {
      handler(value) {
        this.name = value.name;
        this.phone = value.phone;
        this.email = value.email;
      },
      immediate: true,
    },
  },

  mounted() {
    this.getProducts()
    this.getShopCategories()
  },
  methods: {
    getShopInfo() {
      apiRequest.get(`/users/${this.account.id}/shop`, {
      })
        .then((result) => {
          this.shop = {...result.data, delivery: result.data.delivery == true }
        })
    },
    getShopCategories() {
      apiRequest.get(`/categories`, {
      })
        .then((result) => {
          this.categories = result.data
        })
    },
    getProducts() {
      const data = {};

      data.page = this.pagination.currentPage
      data.search = this.filtersValues.search

      apiRequest.get(`/users/${this.account.id}/shop/products`, {
        params: data
      })
          .then((result) => {
            const { data, current_page, last_page, total } = result.data;
            this.products = data;

            this.pagination.totalItems = total;
            this.pagination.totalPages = last_page;
            this.pagination.currentPage = current_page;

            this.loading = false;
          })
          .catch((error) => {
            console.log(error)
          });
    },
    deleteProduct(e, id) {
      e.preventDefault();
      apiRequest.delete(`/admin-product/${id}`)
          .then(() => {
            this.getProducts()
          })
          .catch((error) => {
            console.log(error)
          });
    },
    setCurrentPage(value) {
      window.scrollTo(0, 0)
      this.pagination.currentPage = value;
      this.getProducts()
    },
    productPrice(product) {
      let price = 0;
      // Fonon
      if(product.shop.id === 22) {
        if(product.price) {
          price = product.price
        } else if(product.weight && (product.specification_insert == 'empty' && product.specification_insert2 == 'empty')) {
          if(product.specification_probe == 583 || product.specification_probe == 585) {
            price = product.weight * product.shop.probe_583_price
          } else if(product.specification_probe == 750) {
            price = product.weight * product.shop.probe_750_price
          }
        }
      }
      // jeWell
      else if(product.shop.id === 21 || product.shop.id === 19) {
        price = 10581 * product.price
      } else {
        price = product.price
      }

      if(price) {
        return Intl.NumberFormat('uz-UZ', { minimumFractionDigits: 0 }).format(price) + ' сум'
      } else return ''
    },
    getImage(image) {
      const imageCont = image.split('.');
      return `${process.env.VUE_APP_STORAGE}/${imageCont[0]}-cropped.${imageCont[1]}`
    },
    updateInfo(e) {
      e.preventDefault();
      console.log(e.target)

      var formData = new FormData(e.target);
      console.log(this.productData.categories)

      for(let name in this.productData) {
        if(name !== 'categories') {
          formData.append(name, this.productData[name])
        } else {
          formData.append('categories', this.productData.categories.map((category) => category.id))
        }
        
      }

      if(this.productData.is_on_main == false) {
        formData.append('is_on_main', 0);
      } else if(this.productData.is_on_main == true) {
        formData.append('is_on_main', 1);
      }
      let url = `/admin-product/user/${this.account.id}`
      if(this.productData.id) {
        url = `/admin-product/${this.productData.id}`
      }
      apiRequest.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
        .then((result) => {
          this.productData = {...result.data, delivery: result.data.is_on_main == true }
          alert('Успешно обновлено');
        })
    },
    handleImport(e) {
      e.preventDefault();

      const formData = new FormData();
      formData.append("file", e.target.files[0]);
      formData.append("user_id", this.account.id);

      apiRequest.post('/import', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
        .then(() => {
          this.getProducts()
          alert('Успешно загружено');
        })
    },
    checkProduct(id) {
      if(this.checkedProduct(id)) {
        this.checkedProducts = this.checkedProducts.filter(productId => productId !== id)
      } else {
        this.checkedProducts.push(id)
      }
    },
    checkedProduct(id) {
      return this.checkedProducts.some(productId => productId === id)
    },
    deleteCheckedProducts() {
      const data = { products: this.checkedProducts }
      apiRequest.post(`/admin-products/delete`, data)
          .then(() => {
            this.getProducts()
          })
          .catch((error) => {
            console.log(error)
          });
    },
    searchProducts() {
      this.loading = true
      this.getProducts()
    }
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss" scoped>
@import "~@storefront-ui/vue/styles";
.form {
  @include for-desktop {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
  &__element {
    margin: 0 0 var(--spacer-lg) 0;
    @include for-desktop {
      flex: 0 0 100%;
    }
    &--half {
      @include for-desktop {
        flex: 1 1 50%;
      }
      &-even {
        @include for-desktop {
          padding: 0 0 0 var(--spacer-lg);
        }
      }
    }
    textarea {
      width: 100%;
    }
  }
  &__button {
    --button-width: 100%;
    @include for-desktop {
      --button-width: 17.5rem;
    }
  }
}
.message {
  margin: 0 0 var(--spacer-xl) 0;
  color: var(--c-dark-variant);
}
.notice {
  margin: var(--spacer-base) 0 0 0;
  font-size: var(--font-size--sm);
}
a {
  color: var(--c-primary);
  text-decoration: none;
  &:hover {
    color: var(--c-text);
  }
}
</style>

<style lang="scss">
.multiselect__tags {
  background: hsla(0,0%,80%,.14901960784313725);
    padding-left: 10px;
    border: none;
    height: var(--select-height, 4.25rem);
}
.multiselect__tag {
  background-color: #f5b800ba;
}

.multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
    background: #a17900ba;
}

.multiselect__tag-icon:after {
  color: #443300ba;
}

.multiselect__option--highlight {
  background: #f5b800ba;
}

.multiselect__option::after {
  background: #a17900ba;
}
.shop-products {
  .products {
    box-sizing: border-box;
    flex: 1;
    margin: 0;
    &__grid,
    &__list {
      display: flex;
      flex-wrap: wrap;
    }
    &__product-card {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    &__product-card-horizontal {
      flex: 0 0 100%;
    }
    &__slide-enter {
      opacity: 0;
      transform: scale(0.5);
    }
    &__slide-enter-active {
      transition: all 0.2s ease;
      transition-delay: calc(0.1s * var(--index));
    }
    @include for-desktop {
      &__grid {
        margin: var(--spacer-sm) 0 0 var(--spacer-sm);
      }
      &__pagination {
        display: flex;
        justify-content: flex-start;
        margin: var(--spacer-xl) 0 0 0;
      }
      &__product-card-horizontal {
        margin: var(--spacer-lg) 0;
      }
      &__product-card {
        flex: 1 1 25%;
      }
      &__list {
        margin: 0 0 0 var(--spacer-sm);
      }
    }
    &__show-on-page {
      display: flex;
      justify-content: flex-end;
      align-items: baseline;
      &__label {
        font-family: var(--font-family--secondary);
        font-size: var(--font-size--sm);
      }
    }
  }

  .sf-select {
    width: 100%;
  }

  .sf-product-card__wishlist-icon {
    display: none;
  } 

  .form__element {
    textarea {
      width: 100%;
    }
  } 
}

.product__select {
  &-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.1);
    padding: var(--product-card-padding, var(--spacer-xs));
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    &.active {
      background-color: rgba(0,0,0,0.2);
    }
  }  
}

</style>